// SEM_ATIVAR_APPS_2810 / SEM_CARTEIRA_2810: esconde Ativar aplicativos e A minha carteira.
// Desligar: private/SEM_ATIVAR_APPS_2810_OFF ou private/SEM_CARTEIRA_2810_OFF
import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuraxFlags } from './auraxFlags';
import './semApps2810.css';

export function hidePath2810(path, flags) {
  const p = String(path || '').split('?')[0].replace(/\/+$/, '');
  if (flags?.sem_ativar_apps_2810 && p.startsWith('/app-activations')) return true;
  // MENU_SO_WHATSAPP_0311 (fix2): some Atendimentos/DataCrazy Chat/Funil em todo menu, abas e celular (switch private/MENU_SO_WHATSAPP_OFF)
  if (flags?.menu_so_whatsapp && ['/chats', '/atendimento', '/funnel'].some((h) => p === h || p.startsWith(`${h}/`))) return true;
  if (flags?.sem_carteira_2810 && p === '/gestor-xui/my-portfolio') return true;
  // EXTRAS_2910: módulos opcionais não adicionados somem do menu da revenda
  if (p === '/extras' && !flags?.extras_2910) return true;
  // VENCIMENTOS_2910 / PASSO_A_PASSO_2910: somem do menu se desligados
  if (p === '/gestor-xui/vencimentos' && flags && flags.vencimentos_2910 === false) return true;
  if (p === '/gestor-xui/passo-a-passo' && flags && flags.passo_a_passo_2910 === false) return true;
  // EXTRAS_FIX_2910: também esconde sub-rotas (/chats/123, /triggers/chatbot...)
  if (Array.isArray(flags?.extras_hide_2910) && flags.extras_hide_2910.some((h) => p === h || p.startsWith(`${h}/`))) return true;
  // FIN_REVENDA_2910: revenda não vê Carteira/Comprar créditos/Cobrança de revendas
  if (flags?.fin_revenda_2910 && ['/buy-credits', '/postpaid-wallet', '/gestor-xui/reseller-billing', '/gestor-xui/my-reseller-billing'].includes(p)) return true;
  return false;
}

export function useBodyFlags2810(flags) {
  useEffect(() => {
    const b = document.body;
    if (flags?.sem_ativar_apps_2810) b.setAttribute('data-sem-apps-2810', '1'); else b.removeAttribute('data-sem-apps-2810');
    if (flags?.sem_carteira_2810) b.setAttribute('data-sem-carteira-2810', '1'); else b.removeAttribute('data-sem-carteira-2810');
    // SEM_ROLAGEM_PC_2810: tira rolagem desnecessária no PC (switch private/SEM_ROLAGEM_PC_2810_OFF)
    if (flags?.sem_rolagem_pc_2810) b.setAttribute("data-sem-rolagem-pc-2810", "1"); else b.removeAttribute("data-sem-rolagem-pc-2810");
    // VISTA_COMPACTA_2910 (switch private/VISTA_COMPACTA_2910_OFF)
    if (flags?.vista_compacta_2910) b.setAttribute('data-vista-compacta-2910', '1'); else b.removeAttribute('data-vista-compacta-2910');
  }, [flags?.sem_ativar_apps_2810, flags?.sem_carteira_2810, flags?.sem_rolagem_pc_2810, flags?.vista_compacta_2910]);
}

export function Hide2810({ flag, to = '/gestor-xui/clients', children }) {
  const flags = useAuraxFlags();
  if (!flags) return null;
  return flags[flag] ? <Navigate to={to} replace /> : children;
}
